import { Incident } from "api";

export enum StatusRaceControl {
    IN_PROGRESS = "IN_PROGRESS",
    PENDING = "PENDING",
    FINISHED = "FINISHED",
}

export enum StatusRaceControlDescription {
    IN_PROGRESS = "Em andamento",
    PENDING = "Pendente",
    FINISHED = "Finalizada",
}

export interface RaceControl {
    id?: string;
    championshipId?: string;
    roundId?: string;
    raceId?: string;
    raceNumber?: number;
    createdBy?: string;
    createdAt?: any;
    incidents?: Incident[];
    status?: StatusRaceControl;
}

export const RaceControlDefault: RaceControl = {
    incidents: [],
    status: StatusRaceControl.IN_PROGRESS,
};
